import React from 'react';
import { useNavigate } from 'react-router-dom';

const VerifyEmailNotice = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#255CFF] px-4">
            <div className="bg-white p-8 rounded-2xl shadow-lg max-w-md text-center">
                <h1 className="text-2xl md:text-3xl font-bold text-[#255CFF] mb-4">
                    Verify Your Email
                </h1>
                <p className="text-gray-700 mb-6">
                    A verification link has been sent to your email. Please check your inbox and follow the link to activate your account.
                </p>
                <button
                    onClick={() => navigate('/login')}
                    className="mt-4 bg-[#255CFF] text-white px-6 py-2 rounded-md hover:bg-[#1e4de6] transition"
                >
                    Back to Login
                </button>
            </div>
        </div>
    );
};

export default VerifyEmailNotice;
